import React, { Component } from 'react';
import speedtestLogo from './../../images/common-static/logos/logo_speedtest.svg';
import hamburgerIcon from './../../images/common-static/icons/ic_hamburger.svg';
import closeIcon from './../../images/common-static/icons/ic_close.svg';
import gridIcon from './../../images/common-static/icons/ic_grid.svg';
import bookIcon from './../../images/common-static/icons/ic_book.svg';
import chartsIcon from './../../images/common-static/icons/ic_charts.svg';
import fileIcon from './../../images/common-static/icons/ic_file.svg';
import helpIcon from './../../images/common-static/icons/ic_help.svg';
import chatIcon from './../../images/common-static/icons/ic_chat.svg';
import styles from './global-nav.css';
import iosAppPromo from './../../images/masthead-app-promo-ios-1x.png';
import iosAppPromo2x from './../../images/masthead-app-promo-ios-2x.png';
import androidAppPromo from './../../images/masthead-app-promo-android-1x.png';
import androidAppPromo2x from './../../images/masthead-app-promo-android-2x.png';
import MastheadEventHandlers, {_events} from './masthead-event-handlers';

export default class GlobalNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      forceMobileNavVisibility: false
    };
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      MastheadEventHandlers();
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      const nav = document.querySelector('.nav-menu');
      if (nav) {
        nav.removeEventListener('click', _events.handleClickEvent);
        nav.removeEventListener('mouseenter', _events.handleMouseEnterandFocusEvent, true);
        nav.removeEventListener('focusin', _events.handleMouseEnterandFocusEvent, true);
        nav.removeEventListener('focusout', _events.handleFocusOutandMouseLeaveEvent, true);
        nav.removeEventListener('mouseleave', _events.handleFocusOutandMouseLeaveEvent, true);
      }
      document.querySelectorAll('.nav-item-text').forEach((item) => {
        item.removeEventListener('keydown', _events.handleKeyDownEnterEvent);
      });
    }
  }

  render() {
    return (
      <div className={`${styles.globalNav} masthead masthead-dark`}>
        <div className="container">
          <div className="masthead-container">
            <div className="nav">
              <div className="pure-g">
                <div className="pure-u-1 pure-u-lg-1-5 u-c" role="banner">
                  <a className="masthead-logo" href="/" aria-label="Speedtest">
                    <svg className="svg-icon svg-icon-speedtest-logo">
                      <svg dangerouslySetInnerHTML={{ __html: speedtestLogo }} />
                    </svg>
                  </a>
                </div>
                <nav className="pure-u-1 pure-u-lg-4-5 nav-container" role="navigation">
                  <div className={`${styles.navMobileControls} nav-mobile-controls`}>
                    <a
                      className="nav-hamburger"
                      aria-label="Open Navigation"
                      href="#"
                      style={this.state.forceMobileNavVisibility ? { display: 'none' } : {}}
                      onClick={(e) => {
                        e.preventDefault();
                        document.body.classList.add('nav-opened');
                        this.setState({
                          forceMobileNavVisibility: !this.state.forceMobileNavVisibility
                        });
                      }}
                    >
                      <svg className="svg-icon svg-icon-larger">
                        <svg dangerouslySetInnerHTML={{ __html: hamburgerIcon }} />
                      </svg>
                    </a>
                    <a
                      className="nav-close"
                      aria-label="Close Navigation"
                      href="#"
                      style={this.state.forceMobileNavVisibility ? { display: 'block' } : {}}
                      onClick={(e) => {
                        e.preventDefault();
                        document.body.classList.remove('nav-opened');
                        this.setState({
                          forceMobileNavVisibility: !this.state.forceMobileNavVisibility
                        });
                      }}
                    >
                      <svg className="svg-icon svg-icon-larger">
                        <svg dangerouslySetInnerHTML={{ __html: closeIcon }} />
                      </svg>
                    </a>
                  </div>
                  <div className={`${styles.navMenu} nav-menu`} style={this.state.forceMobileNavVisibility ? { display: 'block' } : {}}>
                    <div className="u-hidden u-show-platform-ios">
                      <a className="promo-container" href="itms-apps://apps.apple.com/us/app/speedtest-by-ookla/id300704847"
                         target="_blank" aria-label="Download the Speedtest app on the App Store">
                        <img className="promo-banner"
                             alt="Speedtest app promo" role="presentation"
                             src={iosAppPromo}
                             srcSet={`${iosAppPromo2x} 2x`}/>
                      </a>
                    </div>
                    <div className="u-hidden u-show-platform-android">
                      <a className="promo-container" href="https://play.google.com/store/apps/details?id=org.zwanoo.android.speedtest"
                         target="_blank" aria-label="Download the Speedtest app on Google Play">
                        <img className="promo-banner"
                             alt="Speedtest app promo" role="presentation"
                             src={androidAppPromo}
                             srcSet={`${androidAppPromo2x} 2x`}/>
                      </a>
                    </div>
                    <ul className="pure-u-1 pure-u-lg-4-5 u-c padding-right-0">
                      <li>
                        <span className="nav-item-text">
                          <svg className="svg-icon hamburger-view">
                              <svg dangerouslySetInnerHTML={{ __html: gridIcon }} />
                          </svg>
                          <a href="/apps" className='nav-link'>
                            Apps
                          </a>
                        </span>
                        <ul className="sub-menu">
                          <li>
                            <a href="/apps/android">
                              Android
                            </a>
                          </li>
                          <li>
                            <a href="/apps/appletv">
                              Apple TV
                            </a>
                          </li>
                          <li>
                            <a href="/apps/ios">
                              iOS
                            </a>
                          </li>
                          <li>
                            <a href="/apps/mac">
                              macOS
                            </a>
                          </li>
                          <li>
                            <a href="/apps/windows">
                              Windows
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <span className="nav-item-text">
                          <svg className="svg-icon hamburger-view">
                            <svg dangerouslySetInnerHTML={{ __html: bookIcon }} />
                          </svg>
                          <a href="/about/knowledge" className='nav-link'>
                            Learn
                          </a>
                        </span>
                        <ul className="sub-menu">
                          <li><a href="/about/knowledge/glossary">Glossary</a></li>
                          <li><a href="/about/knowledge/guides">Guides</a></li>
                          <li><a href="/about/knowledge/faq">FAQ</a></li>
                        </ul>
                      </li>
                      <li>
                        <span className="nav-item-text">
                          <svg className="svg-icon hamburger-view">
                            <svg dangerouslySetInnerHTML={{ __html: chartsIcon }} />
                          </svg>
                          Data
                        </span>
                        <ul className="sub-menu">
                          <li><a href="https://www.ookla.com/articles">Ookla Research<sup>™</sup></a></li>
                          <li><a href="/awards">Speedtest Awards<sup>™</sup></a></li>
                          <li><a href="/global-index">Speedtest Global Index<sup>™</sup></a></li>
                          <li><a href="/performance/united-states">Speedtest Performance Directory<sup>™</sup></a></li>
                        </ul>
                      </li>
                      <li>
                        <span className="nav-item-text">
                          <svg className="svg-icon hamburger-view">
                            <svg dangerouslySetInnerHTML={{ __html: fileIcon }} />
                          </svg>
                          About
                        </span>
                        <ul className="sub-menu">
                          <li><a href="/apps">Apps</a></li>
                          <li><a href="https://www.ookla.com/resources/guides/speedtest-methodology">Methodology</a></li>
                          <li><a href="https://www.ookla.com/about/press">Press</a></li>
                          <li><a href="https://www.ookla.com">Ookla</a></li>
                          <li><a href="/about/advertising">Advertise</a></li>
                        </ul>
                      </li>
                    </ul>
                    <ul className="pure-u-1 pure-u-lg-1-12 u-c">
                      <li className="hamburger-view">
                        <a href='/help'>
                          <svg className="svg-icon">
                            <svg dangerouslySetInnerHTML={{ __html: chatIcon }} />
                          </svg>
                          HELP
                        </a>
                      </li>
                      <li className="u-hidden u-visible-lg">
                        <a href="/help" className="nav-item-text" title="Help">
                          <svg className="svg-icon" aria-label="Help" title="Help">
                            <svg dangerouslySetInnerHTML={{ __html: helpIcon }} />
                          </svg>
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
